import React, { useEffect, useRef } from 'react';
import { useLoadingCtx } from '../context/LoadingContext';
import assets from '../assetsList';
import { CookieService } from '../services/Services';

const fetchLangKey = 'cachedLangs'

const useCacheLoad = () => {
    const [fetchedAssets, setFetchedAssets] = React.useState({
        en: false,
        he: false,
        ru: false,
        ar: false,
    });
    const { setIsVisible, setIsGameReady, isGameReady, setCompleted } = useLoadingCtx();
    const initial = useRef(true);

    // async function fetchNext() {
    //     const langs = Object.keys(fetchedAssets);
    //     for (let i = 0; i < langs.length; i++) {
    //         const lang = langs[i];
    //         if (!fetchedAssets[lang] && lang) {
    //             const startFetchMessage = {
    //                 type: 'loadAsset',
    //                 language: lang,
    //                 isInitial: false,
    //             }
    //             await sendServiceWorkerMessage(startFetchMessage);
    //             break; // this is important, otherwise iteration will cancel previous fetch
    //         }
    //     }
    // };

    useEffect(() => {
        if (initial.current) {
            initial.current = false;
            return;
        }

        const message = JSON.stringify({ fetchedAssets });
        // Update cookies every time when new language is cached. 
        // Update cookies every time when fetchedAssets is updated
        CookieService.setCookie(fetchLangKey, message);

        // fetchNext();
    }, [fetchedAssets]);

    const handleServiceWorkerMessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.type === 'loadAsset') {
            console.log('Recieved SW message', data);
            setFetchedAssets((prevState) => ({
                ...prevState,
                [data.language]: true,
            }))
            if (data?.isInitial) {
                setIsGameReady(true);
            }
        }
    };

    // isUrlInCache(url){
    //     return new Promise(resolve=>{
    //       caches.match(url).then(cachedResponse=> {resolve(!!cachedResponse)});
    //     });
    //   }

    //   const checkCache = this.isUrlInCache("/v1.0/games_engine/games/homes-43/sound/"+lang+"/g043-074-00-end-game.mp3").then(res=>{
    //          return (res  ? lang : null);
    //     });
    // const checkCache = async () => {
    // const cache = await caches.open('offline-cache');
    // const keys = await cache.keys();
    // const languages = keys.map((key) => {
    //     const parts = key.url.split('/');
    //     const lang = parts[parts.length - 2];
    //     return Object.keys(fetchedAssets).includes(lang) ? lang : null
    // })
    // function isCached(url) {
    //     new Promise(resolve => {
    //         caches.match(url).then(cachedResponse => {
    //             return cachedResponse.ok;
    //         });
    //     });
    //     return false;
    // }

    const checkCache = () => {
        //        const unique = Array.from(new Set(languages));
        // for (let key in newKeys) {
        //     //            if (unique.includes(key)) {
        //     var url = "/v1.0/games_engine/games/homes-43/sound/" + key + "/g043-074-00-end-game.mp3";
        //     newKeys[key] = isCached(url);
        //     console.log('checkCache', key, ':', newKeys[key]);

        //     //            }
        // }
        // }

        // setFetchedAssets(newKeys);

        const cookie = CookieService.getCookie(fetchLangKey) || null;
        if (!cookie) {
            const message = JSON.stringify({ fetchedAssets });
            CookieService.setCookie(fetchLangKey, message);
        } else {
            const message = JSON.parse(cookie);
            setFetchedAssets((prevState) => ({ ...prevState, ...message.fetchedAssets }));
        }

    };

    useEffect(() => {
        checkCache();
    }, []);

    const checkSpecificLangInCookies = (lang) => {
        const cookie = CookieService.getCookie(fetchLangKey) || null;
        if (!cookie) {
            return false;
        } else {
            const message = JSON.parse(cookie);
            return message?.fetchedAssets?.[lang];
        }
    };

    // useEffect(() => {
    //     if (navigator.serviceWorker) {
    //         navigator.serviceWorker.addEventListener("message", handleServiceWorkerMessage);
    //     }

    //     return () => {
    //         if (navigator.serviceWorker) {
    //             navigator.serviceWorker.removeEventListener("message", handleServiceWorkerMessage);
    //         }
    //     }
    // }, []);


    // function sendServiceWorkerMessage(message) {
    //     return new Promise((resolve, reject) => {
    //         if (!navigator?.serviceWorker) {
    //             reject('Browser does not support service worker');
    //             return;
    //         }

    //         navigator.serviceWorker.ready
    //             .then((registration) => {
    //                 // Here on first launch of the worker the message of start downloading of the assets is sent
    //                 registration.active.postMessage(JSON.stringify(message));
    //                 resolve();
    //             }).catch((err) => {
    //                 reject(err);
    //             });
    //     });
    // };

    const maxRetries = 3;

    //const cacheFile = async (fileUrl) => {
    async function cacheFile(fileUrl){
        let retryCount = 0;

        while (retryCount < maxRetries) {
            try {
                const cache = await caches.open('offline-cache');
                await cache.add(fileUrl);
                //console.log(`File ${fileUrl} has been cached successfully.`);
                break; // Exit the loop if caching is successful
            } catch (error) {
                console.error(`Error caching file ${fileUrl}:`, error);
                retryCount++;
            }
        }

        if (retryCount === maxRetries) {
            console.error(`Max retries reached. Unable to cache file ${fileUrl}.`);
            // Handle the situation where caching fails after multiple retries.
        }
    };

    //const cacheAllFiles = async (language) => {
    async function cacheAllFiles(language){
        var countAssets = 0;
        const onePercent = 100 / (assets[language]).length;
        for (const fileUrl of assets[language]) {
            await cacheFile(fileUrl);
            setCompleted(Math.floor((++countAssets) * onePercent) + 1);
        }
    };

    const fetchAssetForground = async (language) => {
        if (fetchedAssets?.[language]) {
            return;
        }

        const isInCookies = checkSpecificLangInCookies(language);

        if (isInCookies) {
            return;
        }

        setIsVisible(true);
        cacheAllFiles(language)
        // const cache = await caches.open('offline-cache');
        // //await cache.addAll(assets[language])
        // cache.addAll(assets[language])
        //         .catch(console.error)
                .then(() => {
                    console.log('fetchAssetForground - We do cleanup here'); 
                    setIsGameReady(true);
    
                    setFetchedAssets((prevState) => ({
                        ...prevState,
                        [language]: true,
                    }));
                    setIsVisible(false); 
                    //window.location.reload(); 
                    //console.log('window.location', window.location);                  
                    //window.location = window.location.origin + "/?statusApp=1";
                });
    };

//     async function fetchInitialAssetBackground(language, isOnline) {
// //        if (CookieService.getCookie("statusApp") != 1)
// //            return;
//         let isCached = false;
//         if (fetchedAssets?.[language]) {
//             isCached = true;
//         }

//         const isInCookies = checkSpecificLangInCookies(language);

//         if (isInCookies) {
//             isCached = true;
//         }
       
//         if (isCached && !isGameReady) {
//             setIsGameReady(true);
//             return;
//         }
    
//         if (!isOnline) {
//             setIsGameReady(true);
//             return;
//         }

//         if (isCached) {
//             return;
//         }

//         const startFetchMessage = {
//             type: 'loadAsset',
//             language,
//             isInitial: true,
//         }
//         await sendServiceWorkerMessage(startFetchMessage);
//     };

    return {
        fetchedAssets,
//        fetchInitialAssetBackground,
        fetchAssetForground,
        checkSpecificLangInCookies
    }
};

export default useCacheLoad;